import { TranslatableText, Translate } from '@dreryk/react-common';
import { IconFillColor, IconSize, IconWrapper, StyledFlex, TestId } from '@dreryk/react-components';

type MedicineSelectorTabLabelProps = {
   readonly testId: TestId;
   readonly icon?: JSX.Element;
   readonly label: TranslatableText;
};

export const MedicineSelectorTabLabel = (props: MedicineSelectorTabLabelProps): JSX.Element => {
   return (
      <StyledFlex gap={'4px'}>
         {props.icon ? (
            <IconWrapper testId={props.testId} size={IconSize.SMALLEST} fillColor={IconFillColor.CURRENT_COLOR}>
               {props.icon}
            </IconWrapper>
         ) : null}
         <Translate>{props.label}</Translate>
      </StyledFlex>
   );
};
